import { render, staticRenderFns } from "./UserList.vue?vue&type=template&id=d4898acc&"
import script from "./UserList.js?vue&type=script&lang=js&"
export * from "./UserList.js?vue&type=script&lang=js&"
import style0 from "./UserList.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports